import type { PrintOptions, PrintResult, Printer } from './printTypes';

/**
 * Implementación de impresión para la aplicación de escritorio Electron.
 *
 * Toda la comunicación se hace a través del bridge seguro expuesto por el preload
 * (window.electronAPI). El renderer nunca accede directamente a Node.js ni al SO.
 */
export class ElectronPrintService {
  readonly runtime = 'ELECTRON' as const;

  private get api() {
    return window.electronAPI;
  }

  async listPrinters(): Promise<Printer[]> {
    if (!this.api?.getPrinters) return [];
    try {
      return await this.api.getPrinters();
    } catch {
      return [];
    }
  }

  async printHTML(html: string, options?: PrintOptions): Promise<PrintResult> {
    if (!this.api?.printHTML) {
      return { success: false, message: 'El bridge de Electron no está disponible.' };
    }
    try {
      return await this.api.printHTML(html, options);
    } catch (err) {
      return {
        success: false,
        message: err instanceof Error ? err.message : 'No se pudo imprimir.',
      };
    }
  }

  async printTest(printerName?: string): Promise<PrintResult> {
    if (!this.api?.testPrint) {
      return { success: false, message: 'El bridge de Electron no está disponible.' };
    }
    try {
      return await this.api.testPrint(printerName);
    } catch (err) {
      return {
        success: false,
        message: err instanceof Error ? err.message : 'No se pudo imprimir la prueba.',
      };
    }
  }

  async openCashDrawer(): Promise<PrintResult> {
    if (!this.api?.openCashDrawer) {
      return { success: false, message: 'La gaveta no está disponible.' };
    }
    try {
      return await this.api.openCashDrawer();
    } catch (err) {
      return {
        success: false,
        message: err instanceof Error ? err.message : 'No se pudo abrir la gaveta.',
      };
    }
  }
}